import React, { Component } from 'react';
import '../stylesheets/inventory.sass'
import { selectors as inventorySelectors } from '../sagas/inventory'
import { actions } from '../sagas/inventory/new'
import { Crementer } from '../shared/NumberCrementer'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync'
import KegSize from './KegSize'

class Row extends Component {

  render() {
    return(
      <div className='inventory_row'>
        { this.props.product &&
          this.props.product['attributes'] &&
        <div className='inventory_row_wrapper'>
          <div className='inventory_col_one'>
          </div>
          <div className='column-one inventory-col name'>
            <div>
              { this.props.product['attributes']['name']}
            </div>
          </div>
          <ScrollSyncPane>
            <div className='scroll'>
              { this.props.kegSizes && this.props.kegSizes.map( size => {
                  return (
                    <KegSize
                      style= {{ minWidth: 200, width: `${100/this.props.kegSizes.length}%` }}
                      key={ size['id'] }
                      product = { this.props.product }
                      size= { size }
                    />
                  )
                })
              }
            </div>
          </ScrollSyncPane>
        </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  loaded: inventorySelectors.loaded(store)
})

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      inventoryActions: bindActionCreators(actions, dispatch),
    }
  }
}

export default (connect(mapStateToProps, null)(Row))



// WEBPACK FOOTER //
// ./src/Inventory/Row.jsx